import React, { useState } from "react";
import { PatientEnrolmentForm, PatientEnrolmentConfirm } from ".";
import { useNavigate } from "react-router";

const PatientEnrolment = (props) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = React.useState(0);

  const [state, setState] = React.useState({
    title: "",
    first_name: "",
    surname: "",
    dob: "",
    postcode: "",
    indigenous: "",
    ndss: "",
    hba1c: "",
    last_eye_test: "",
    follow_up_sms: false,
    follow_up_sms_number: "",
    follow_up_email: false,
    follow_up_email_address: "",
    follow_up_post: false,
    follow_up_post_address: "",
    patient_consent: false,
    recaptcha_token: null,
  });

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    window.scrollTo(0, 0);
  };

  const previousPage = () => {
    const newState = { ...state, recaptcha_token: null };

    setCurrentPage(currentPage - 1);
    setState(newState);

    window.scrollTo(0, 0);
  };

  const saveEnrolmentForm = (values) => {
    setState({
      title: values.title,
      first_name: values.first_name,
      surname: values.surname,
      dob: values.dob,
      postcode: values.postcode,
      ndss: values.ndss,
      indigenous: values.indigenous,
      hba1c: values.hba1c,
      last_eye_test: values.last_eye_test,
      follow_up_sms: values.follow_up_sms,
      follow_up_sms_number: values.follow_up_sms_number,
      follow_up_email: values.follow_up_email,
      follow_up_email_address: values.follow_up_email_address.trim(),
      follow_up_post: values.follow_up_post,
      follow_up_post_address: values.follow_up_post_address,
      patient_consent: values.patient_consent,
      recaptcha_token: values.recaptcha_token,
    });

    nextPage();
  };

  const renderForm = () => {
    return (
      <PatientEnrolmentForm
        {...props}
        values={state}
        saveEnrolmentForm={saveEnrolmentForm}
      />
    );
  };

  const renderReview = () => {
    return (
      <PatientEnrolmentConfirm
        {...props}
        values={state}
        previousPage={previousPage}
        navigate={navigate}
      />
    );
  };

  return <div>{currentPage === 0 ? renderForm() : renderReview()}</div>;
};

export default PatientEnrolment;
